import { ResetRatingHintHandler } from './reset-rating-hint-handler';
import { attachRatingInputsEventListeners } from './attach-rating-inputs-event-listeners';

export type InitStarRatingParams = {
    rootElement: Pick<HTMLElement, 'querySelectorAll' | 'querySelector'>;
};
export const initStarRating = ({ rootElement }: InitStarRatingParams): void => {
    const resetRatingHint = ResetRatingHintHandler({ rootElement });
    resetRatingHint();
    attachRatingInputsEventListeners({ rootElement });
};
